import Flatpickr from 'react-flatpickr';
import "flatpickr/dist/themes/dark.css";

const InputDateTime = (props: any) => {

	return  <Flatpickr
        name={props.name}
        className={props.className}
        options={{ minDate: props.minDate, maxDate: props.maxDate, allowInput: true, dateFormat: 'Y-m-d', enableTime: false, disableMobile: props.disableMobile}}
        defaultValue={props.defaultValue}
        value={props.value}
        onChange={(event:any) => props.onChange(event)}
    />
}

export default InputDateTime;
